export default "__VITE_ASSET__CXoKioQK__"